import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronLargeRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChevronLargeRight"><Path fillRule="evenodd" clipRule="evenodd" d="M10.0115 1.72168L16.1227 11.9996L10.0115 22.2776L8.72217 21.511L14.3776 11.9996L8.72217 2.48829L10.0115 1.72168Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronLargeRight;
